export default "__VITE_ASSET__DhLV5iNp__"